import { InjectionToken } from '@angular/core';

export const RED_TAILWIND_EXTRACTED = new InjectionToken<any>('redTailwindExtractedConfig');
